<template>
  <div class="balance-info" :class="{_withdraw: withdraw}">
    <div class="balance-info__wrap">
      <div class="balance-info__inner">
        <div class="balance-info__label">{{ label }}</div>
        <div class="balance-info__val">
          {{ computedValue }}
          <span>JBN</span>
        </div>
      </div>
      <BasePreloader v-if="pending"
                     class="_small"/>
    </div>
    <button v-if="withdraw"
            type="button"
            @click="$vModal.open('cash-request', {canWithdrawSum: +value})"
            class="balance-info__btn base-btn base-btn--green">
      <span class="d-xs-none">{{ $tAccount('Withdrawal request short') }}</span>
      <span class="d-none d-xs-inline">{{ $tAccount('Withdraw') }}</span>
    </button>
  </div>
</template>

<script>
  import formatCurrency from '@/helpers/formatCurrency'

  export default {
    name: 'AccountBalanceInfo',
    props: {
      label: {
        type: String
      },
      value: {
        type: Number
      },
      pending: {
        type: Boolean
      },
      withdraw: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      computedValue() {
        return this.pending ? '000' : formatCurrency(this.value)
      }
      // formatValue() {
      //   let result = this.value.toString()
      //   result = result
      //     .replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1 `)
      //     .replace('-', '')
      //   return result
      // }
    },
    // methods: {
    //   formatCurrency
    // },
    created() {

    }
  }
</script>

<style>

</style>
